<template>
    <div>{{ apiResponse }}</div>
</template>

<script>
export default {
    name: 'MerchantsID',
    data() {
        return {
            apiResponse: '',
            error: ''
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            const token = this.$api.getAuthorization() || '$2y$10$QGjLZTJWHiiYZLTGyPpfTOObVQfLsUAbla9TkTD40a2G9H2JaDYz6';

            const config = {
                headers: { Authorization: `${token}` }
            };

            this.$store
                .dispatch('external/findMerchant', { config: config, id: this.$route.params.id })
                .then((response) => {
                    this.apiResponse = response;
                })
                .catch((error) => {
                    this.error = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message || 'External API Error';
                });
        }
    }
};
</script>
